var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticStyle: { padding: "14px" },
    },
    [
      _c(
        "el-row",
        { staticClass: "row-top", attrs: { gutter: 24 } },
        [
          _c("el-col", { attrs: { span: 6 } }, [
            _c("div", [
              _c("img", {
                attrs: { src: require("@/assets/call/phone1.png"), alt: "" },
              }),
              _c("div", [
                _c("h5", { staticStyle: { color: "#374FB8" } }, [
                  _vm._v(_vm._s(_vm.detail.totalCallDuration || "--")),
                ]),
                _c("p", [_vm._v("通话时长")]),
              ]),
            ]),
          ]),
          _c("el-col", { attrs: { span: 6 } }, [
            _c("div", [
              _c("img", {
                attrs: { src: require("@/assets/call/phone2.png"), alt: "" },
              }),
              _c("div", [
                _c("h5", { staticStyle: { color: "#27D5DF" } }, [
                  _vm._v(_vm._s(_vm.detail.successCallNum || "--")),
                ]),
                _c("p", [_vm._v("拨通数")]),
              ]),
            ]),
          ]),
          _c("el-col", { attrs: { span: 6 } }, [
            _c("div", [
              _c("img", {
                attrs: { src: require("@/assets/call/phone3.png"), alt: "" },
              }),
              _c("div", [
                _c("h5", { staticStyle: { color: "#FF414F" } }, [
                  _vm._v(_vm._s(_vm.detail.failCallNum || "--")),
                ]),
                _c("p", [_vm._v("未通数")]),
              ]),
            ]),
          ]),
          _c("el-col", { attrs: { span: 6 } }, [
            _c("div", [
              _c("img", {
                attrs: { src: require("@/assets/call/phone4.png"), alt: "" },
              }),
              _c("div", [
                _c("h5", { staticStyle: { color: "#FFB85A" } }, [
                  _vm._v(_vm._s(_vm.detail.successCallRate || "--")),
                ]),
                _c("p", [_vm._v("接通率")]),
              ]),
            ]),
          ]),
        ],
        1
      ),
      _c("div", { staticClass: "div-screen" }, [
        _c(
          "div",
          { staticClass: "div-row" },
          [
            _c("span", { staticClass: "span-lable" }, [_vm._v("电话号码：")]),
            _c("el-input", {
              staticClass: "mr-20",
              staticStyle: { width: "200px" },
              attrs: { size: "small", placeholder: "请输入电话号码" },
              on: {
                input: function ($event) {
                  _vm.customerNumber = _vm.customerNumber.replace(/[^\d]/g, "")
                },
                blur: function ($event) {
                  return _vm.handleCurrentChange(1)
                },
              },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.handleCurrentChange(1)
                },
              },
              model: {
                value: _vm.customerNumber,
                callback: function ($$v) {
                  _vm.customerNumber = $$v
                },
                expression: "customerNumber",
              },
            }),
            _c("span", { staticClass: "span-lable" }, [_vm._v("外呼员工：")]),
            _c("el-cascader", {
              ref: "cascader",
              staticClass: "mr-20",
              staticStyle: { width: "200px" },
              attrs: {
                "popper-class": "cascader-department",
                size: "small",
                filterable: "",
                placeholder: "请选择外呼员工",
                options: _vm.options,
                "show-all-levels": false,
                props: _vm.props,
                "collapse-tags": "",
                clearable: "",
              },
              on: { change: _vm.changeCascader },
              model: {
                value: _vm.ownerValue,
                callback: function ($$v) {
                  _vm.ownerValue = $$v
                },
                expression: "ownerValue",
              },
            }),
            _c("span", { staticClass: "span-lable" }, [_vm._v("客户名称：")]),
            _c(
              "el-select",
              {
                staticClass: "mr-20",
                staticStyle: { width: "200px" },
                attrs: {
                  placeholder: "请选择客户名称",
                  size: "small",
                  "filter-method": _vm.filterMethod1,
                  multiple: "",
                  "collapse-tags": "",
                  filterable: "",
                },
                on: {
                  change: function ($event) {
                    return _vm.handleCurrentChange(1)
                  },
                },
                model: {
                  value: _vm.customerIds,
                  callback: function ($$v) {
                    _vm.customerIds = $$v
                  },
                  expression: "customerIds",
                },
              },
              _vm._l(_vm.customerList, function (item) {
                return _c("el-option", {
                  key: item.value,
                  attrs: { label: item.name, value: item.id },
                })
              }),
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "div-row" },
          [
            _c("span", { staticClass: "span-lable" }, [_vm._v("联系人：")]),
            _c(
              "el-select",
              {
                staticClass: "mr-20",
                staticStyle: { width: "200px" },
                attrs: {
                  placeholder: "请选择联系人",
                  size: "small",
                  "filter-method": _vm.filterMethod,
                  multiple: "",
                  "collapse-tags": "",
                  filterable: "",
                },
                on: {
                  change: function ($event) {
                    return _vm.handleCurrentChange(1)
                  },
                },
                model: {
                  value: _vm.contactIds,
                  callback: function ($$v) {
                    _vm.contactIds = $$v
                  },
                  expression: "contactIds",
                },
              },
              _vm._l(_vm.contactList, function (item) {
                return _c("el-option", {
                  key: item.value,
                  attrs: { label: item.name, value: item.id },
                })
              }),
              1
            ),
            _c("span", { staticClass: "span-lable" }, [_vm._v("来源：")]),
            _c(
              "el-select",
              {
                staticClass: "mr-20",
                staticStyle: { width: "200px" },
                attrs: { placeholder: "请选择来源", size: "small" },
                on: {
                  change: function ($event) {
                    return _vm.handleCurrentChange(1)
                  },
                },
                model: {
                  value: _vm.source,
                  callback: function ($$v) {
                    _vm.source = $$v
                  },
                  expression: "source",
                },
              },
              _vm._l(_vm.sourceLists, function (item, i) {
                return _c("el-option", {
                  key: i,
                  attrs: { label: item.label, value: item.value },
                })
              }),
              1
            ),
            _c("a", { staticClass: "a-btn", on: { click: _vm.clickReset } }, [
              _c("img", {
                attrs: {
                  src: require("@/assets/call/icon-chongzhi.png"),
                  alt: "",
                },
              }),
              _vm._v(" 重置"),
            ]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "div-row" },
          [
            _c("span", { staticClass: "span-lable" }, [_vm._v("拨打时间：")]),
            void 0,
            _vm._l(_vm.timeOption, function (item, index) {
              return _c(
                "span",
                {
                  key: index,
                  staticClass: "span-option",
                  class: item.value === _vm.callTime ? "is-select" : " ",
                  on: {
                    click: function ($event) {
                      return _vm.clickTime(item.value)
                    },
                  },
                },
                [_vm._v(_vm._s(item.label) + " ")]
              )
            }),
            _c(
              "span",
              {
                staticClass: "span-option",
                class: _vm.callTime === -1 ? "is-select" : " ",
                staticStyle: { "margin-right": "0" },
                on: {
                  click: function ($event) {
                    return _vm.clickTime(-1)
                  },
                },
              },
              [_vm._v("自定义")]
            ),
            _vm.callTime === -1
              ? _c("el-date-picker", {
                  staticClass: "ml-20",
                  staticStyle: { width: "250px" },
                  attrs: {
                    size: "mini",
                    type: "daterange",
                    "range-separator": "至",
                    "start-placeholder": "开始日期",
                    "end-placeholder": "结束日期",
                    format: "yyyy-MM-dd",
                    "value-format": "yyyy-MM-dd",
                  },
                  on: {
                    change: function ($event) {
                      return _vm.handleCurrentChange(1)
                    },
                  },
                  model: {
                    value: _vm.date,
                    callback: function ($$v) {
                      _vm.date = $$v
                    },
                    expression: "date",
                  },
                })
              : _vm._e(),
          ],
          2
        ),
        _c(
          "div",
          { staticClass: "div-row" },
          [
            _c("span", { staticClass: "span-lable" }, [_vm._v("状态：")]),
            _vm._l(_vm.statusOptions, function (item, index) {
              return _c(
                "span",
                {
                  key: index,
                  staticClass: "span-option",
                  class: item.value === _vm.status ? "is-select" : " ",
                  on: {
                    click: function ($event) {
                      return _vm.clickState(item.value)
                    },
                  },
                },
                [_vm._v(_vm._s(item.label))]
              )
            }),
          ],
          2
        ),
      ]),
      _c(
        "div",
        { staticClass: "div-table" },
        [
          _c("p", { staticClass: "p-title mt-10 mb-20" }, [
            _vm._v("呼叫明细 "),
            _c(
              "span",
              { staticClass: "fr" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "primary" },
                    on: { click: _vm.exportCallRecord },
                  },
                  [_vm._v("导出")]
                ),
              ],
              1
            ),
          ]),
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.tableData,
                "header-cell-style": { color: "#333" },
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", type: "selection", width: "60" },
              }),
              _c("el-table-column", {
                attrs: { label: "客户名称", "show-overflow-tooltip": "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(scope.row.callOutName || "--"))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "contactName",
                  label: "联系人",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(scope.row.contactName || "--"))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "customerNumber",
                  label: "手机号码",
                  width: "110",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "ownerName",
                  label: "归属人",
                  "min-width": "120",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(scope.row.ownerName || "--"))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "userName",
                  label: "外呼员工",
                  "min-width": "100",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "callTime",
                  label: "拨打时间",
                  "min-width": "100",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "status", label: "拨打状态", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status == 3
                          ? _c("play-status", { attrs: { type: "success" } }, [
                              _vm._v("已接通"),
                            ])
                          : _c("play-status", { attrs: { type: "error" } }, [
                              _vm._v("未接通"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "bridgeDurationFormat",
                  label: "通话时长",
                  "min-width": "80",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "previewOutcallLeftClid",
                  label: "客户侧外显",
                  "min-width": "110",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          _vm._s(scope.row.previewOutcallLeftClid || "--")
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "source", label: "来源" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            scope.row.source > 0
                              ? _vm.sourceList[scope.row.source]
                              : "--"
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "140", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status == 3
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.showRecord(scope.row)
                                  },
                                },
                              },
                              [_vm._v("聊天录音")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm.total
            ? _c("pagination", {
                attrs: {
                  pageNum: _vm.pageNum,
                  pageSize: _vm.pageSize,
                  total: _vm.total,
                },
                on: {
                  sizeChange: _vm.handleSizeChange,
                  currentChange: _vm.handleCurrentChange,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "audio-dialog",
          attrs: {
            title: "聊天录音",
            visible: _vm.dialogVisible,
            width: "720px",
            "before-close": _vm.handleCloseDialog,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-row",
            { staticClass: "audio-wrap" },
            [
              _c("el-col", { attrs: { span: 12 } }, [
                _c("p", { staticClass: "grayText" }, [
                  _vm._v("客户名称："),
                  _c("span", { staticClass: "darkText" }, [
                    _vm._v(_vm._s(_vm.currentRecord.callOutName || "--")),
                  ]),
                ]),
                _c("p", { staticClass: "grayText" }, [
                  _vm._v("手机号码："),
                  _c("span", { staticClass: "darkText" }, [
                    _vm._v(_vm._s(_vm.currentRecord.customerNumber || "--")),
                  ]),
                ]),
                _c(
                  "p",
                  { staticClass: "grayText" },
                  [
                    _vm._v("拨打状态： "),
                    _vm.currentRecord.status == 3
                      ? _c("play-status", { attrs: { type: "success" } }, [
                          _vm._v("已接通"),
                        ])
                      : _c("play-status", { attrs: { type: "error" } }, [
                          _vm._v("未接通"),
                        ]),
                  ],
                  1
                ),
              ]),
              _c("el-col", { attrs: { span: 12 } }, [
                _c("p", { staticClass: "grayText" }, [
                  _vm._v("联系人："),
                  _c("span", { staticClass: "darkText" }, [
                    _vm._v(_vm._s(_vm.currentRecord.contactName || "--")),
                  ]),
                ]),
                _c(
                  "p",
                  { staticClass: "grayText flex" },
                  [
                    _vm._v("归属人： "),
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          content: _vm.currentRecord.ownerName,
                          placement: "top-end",
                        },
                      },
                      [
                        _c("span", { staticClass: "darkText ellipsis" }, [
                          _vm._v(_vm._s(_vm.currentRecord.ownerName || "--")),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _c("p", { staticClass: "grayText" }, [
                  _vm._v("通话时长："),
                  _c("span", { staticStyle: { color: "#374FB8" } }, [
                    _vm._v(_vm._s(_vm.currentRecord.bridgeDurationFormat)),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _c("audioPlay", {
            key: _vm.currentRecord.requestUniqueId,
            ref: "audioPlay",
            attrs: { uniqueId: _vm.currentRecord.requestUniqueId },
          }),
        ],
        1
      ),
      _c("detail", {
        ref: "detail",
        attrs: { isAdmin: _vm.isAdmin },
        on: { getData: _vm.loadData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }